import { useState, useEffect } from "react";
import Config from "../../Config";


import InputText from "../../helpers/InputText";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputPostCode from "../../helpers/InputPostCode";
import InputEmail from "../../helpers/InputEmail";
import InputPhone from "../../helpers/InputPhone";
import InputUploader from "../../helpers/InputUploader";
import InputTime from "../../helpers/InputTime";
import InputNIP from "../../helpers/InputNIP";
import InputREGON from "../../helpers/InputREGON";
import InputDecimal from "../../helpers/InputDecimal";



function NewPlace(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState({
        nazwa: '',
        nazwa_valid: false,
        skrot_nazwy: '',
        ulica: '',
        ulica_valid: false,
        nr_domu: '',
        nr_domu_valid: false,
        nr_mieszkania: '',
        kod_pocztowy: '',
        kod_pocztowy_valid: false,
        miasto: '',
        miasto_valid: false,
        nip: '',
        nip_valid: false,
    });




     
    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    
    const valChange = (filedName, val, correct, msg) => {

        //  console.log("valChange: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
        setTab( {...tab, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }

    const goNext = () => {
        console.log("goNext");
    }



    const saveData = () => {


 
        if(!valChecker(tab))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
 
        props.mainView.setProgress(-2);
        

        fetch( Config.url + '/rest_v1,place_new', {
            method: 'POST', 
            body: JSON.stringify(tab), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    //  
                    props.mainView.setProgress(-1);

                    if(res.status != null && res.status == 'OK')
                    {
                        props.mainView.showDialog( props.userData.dic.dlg_notice , "Placówka została dodana. Zaloguj się ponownie.", "ok" ,  (param) => {
                            document.location.href = "/";
                        } );
                    }else
                    {
                        props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_wrong  ,  "ok"  ,null); 
                    }

         } )
         .catch(err => {
                    props.mainView.setProgress(-1);
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }



    return     <div className="view_content">
        
                            <form className="eForm bg_center">

                                        <div className="form_tab">

                                            <div className="form_control">
                                                <div className="fieldName">{props.userData.dic.fr_pl_name}*</div>
                                                <InputText   userData={props.userData} value={tab.nazwa} valChange={valChange} goNext={goNext} name="nazwa" placeholder={props.userData.dic.fr_pl_name + ": "} className=' w300 ' req='1' />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">{props.userData.dic.fr_pl_short}</div>
                                                <InputText    userData={props.userData} value={tab.skrot_nazwy} valChange={valChange} goNext={goNext} name="skrot_nazwy" placeholder={props.userData.dic.fr_pl_short + ": "} className=' w200' req='0' />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">{props.userData.dic.fr_street}*</div>
                                                <InputText   userData={props.userData}   value={tab.ulica} valChange={valChange} goNext={goNext} name="ulica" placeholder={props.userData.dic.fr_street + ": "} className=' w250' req='1' />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">{props.userData.dic.fr_house_num}*</div>
                                                <InputText  userData={props.userData}  value={tab.nr_domu} valChange={valChange} goNext={goNext} name="nr_domu" placeholder={props.userData.dic.fr_house_num + ": "} className=' w50' req='1' />
                                            </div>

                                            
                                            <div className="form_control">
                                                <div className="fieldName">{props.userData.dic.fr_flat_num}</div>
                                                <InputText    userData={props.userData}  value={tab.nr_mieszkania} valChange={valChange} goNext={goNext} name="nr_mieszkania" placeholder={props.userData.dic.fr_flat_num + ": "} className=' w50' req='0' />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">{props.userData.dic.fr_post_code}*</div>
                                                <InputPostCode   userData={props.userData}  value={tab.kod_pocztowy} valChange={valChange} goNext={goNext} name="kod_pocztowy" placeholder={props.userData.dic.fr_post_code + ": "} className=' w50' req='1' />
                                            </div>

                                            
                                            <div className="form_control">
                                                <div className="fieldName">{props.userData.dic.fr_city}*</div>
                                                <InputTextAlpha   userData={props.userData}  value={tab.miasto} valChange={valChange} goNext={goNext} name="miasto" placeholder={props.userData.dic.fr_city + ": "} className=' w150' req='1' firstUp="1" />
                                            </div>



                                            <div className="form_control">
                                                <div className="fieldName">{props.userData.dic.fr_nip}*</div>
                                                <InputNIP   userData={props.userData}  value={tab.nip} valChange={valChange} goNext={goNext} name="nip" placeholder={props.userData.dic.fr_nip + ": "} className=' w150' req='1'   />
                                            </div>

                                        </div>

                                        
                                         <div className="form_split"></div>

                                        <div className="form_btn">
                                                <div className="btn" onClick={saveData}>Utwórz nową placówkę</div>
                                        </div>


                            </form>

    </div>
}


export default NewPlace;